module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Lighting-Eye-Savers.4e594df8.png";